import React from 'react';
import PropTypes from 'prop-types';
import LitBackgroundImage from './images/LitBackgroundImage';
import { graphql, useStaticQuery } from 'gatsby';
import { navigate } from 'gatsby';
import PostcodeSearch from './PostcodeSearch';

const HeroSection = ({
  children,
  heading,
  subheading,
  smallsubheading,
  className,
  backgroundImage,
  backgroundData,
  backgroundUrl,
  availabilityButton,
}) => {
  // Swapped to using Art direction to replace the settings added in the scss

  // If no Gatsby image data is defined, apply an image directly from URL

  const data = query();
  if (backgroundData) {
    return (
      <LitBackgroundImage
        image={backgroundData.childImageSharp.gatsbyImageData}
        className={className}
        style={{ minHeight: '40rem' }}
      >
        <div className="container-fluid text-center">
          {children}

          {heading && <h1 className="text-center">{heading}</h1>}
          {subheading && <h2 className="text-center">{subheading}</h2>}
          {!subheading && smallsubheading && (
            <h1 className="text-center small">{smallsubheading}</h1>
          )}
          {subheading && smallsubheading && (
            <h5 className="text-center">{smallsubheading}</h5>
          )}
          {availabilityButton && (
            <button
              className="button heroButton"
              onClick={() => navigate('/get-lit/')}
            >
              Check availability
            </button>
          )}
        </div>
      </LitBackgroundImage>
    );
  } else {
    // For the BackgroundImage to work we need to convert these using the bridge

    // If a URL hasn't been passed in then use the public URL of the standard hero image
    // NB this uses images directly, to use a Gatsby image for this section it should use LitBackgroundImage rather than <section> with CSS
    const bgUrl = backgroundUrl ? backgroundUrl : data.svgImage.publicURL;

    return (
      <section
        className={`container-fluid ${className}`}
        style={{
          backgroundImage: `url(${bgUrl})`,
        }}
      >
        {children}
        {heading && <h1 className="text-center">{heading}</h1>}
        {subheading && <h2 className="text-center">{subheading}</h2>}
        {!subheading && smallsubheading && (
          <h1 className="text-center small">{smallsubheading}</h1>
        )}
        {subheading && smallsubheading && (
          <h5 className="text-center">{smallsubheading}</h5>
        )}
      </section>
    );
  }
};

HeroSection.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  smallsubheading: PropTypes.string,
  backgroundImage: PropTypes.string,
  className: PropTypes.string,
};

HeroSection.defaultProps = {
  subheading: '',
  smallsubheading: '',
  className: '',
  backgroundImage: '',
};

export default HeroSection;

const query = () =>
  useStaticQuery(graphql`
    {
      svgImage: file(relativePath: { eq: "hero-images/homeBackground.svg" }) {
        name
        relativePath
        extension
        publicURL
      }
    }
  `);
